import { render, staticRenderFns } from "./LichSuAmThucForm.vue?vue&type=template&id=444b6c89"
import script from "./LichSuAmThucForm.vue?vue&type=script&lang=js"
export * from "./LichSuAmThucForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports